/* eslint-disable jira/naming/disallow-filenames */

import React from 'react';
import type ForgeGlobalPageType from '@jira/spa-apps__forge-global/src/ForgeGlobalPageShellWithAnalytics.tsx';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';

// oxlint-disable-next-line @typescript-eslint/no-explicit-any
export const LazyForgeGlobalPage: LazyComponent<React.ComponentType<Record<any, any>>> =
	lazyForPaint<typeof ForgeGlobalPageType>(
		() =>
			import(
				/* webpackChunkName: "async-forge-spa-global", jiraSpaEntry: "async-forge-spa-global" */ '@jira/spa-apps__forge-global/src/ForgeGlobalPageShellWithAnalytics.tsx'
			),
	);

export const ForgeGlobalPage = (): React.JSX.Element => (
	<LazyPage Page={LazyForgeGlobalPage} pageId="forge-spa-global" shouldShowSpinner />
);

export default ForgeGlobalPage;
